import { render, staticRenderFns } from "./taskLink.vue?vue&type=template&id=5c2e50ee&"
import script from "./taskLink.vue?vue&type=script&lang=js&"
export * from "./taskLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports